/* tslint:disable:max-line-length */
import React from 'react';
import { IconTypeProps } from '../types';
import classNames from 'classnames';

export const TriangleWarningIcon = ({
  className,
  style,
  color = '#FA8C16',
  onClick,
}: IconTypeProps) => {
  return (
    <svg
      className={classNames(className)}
      onClick={onClick}
      style={style}
      width="24"
      height="21"
      viewBox="0 0 24 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M23.25 15.28 15.2 2.25a3.75 3.75 0 0 0-6.38 0L.75 15.28A3.75 3.75 0 0 0 3.94 21h16.12a3.75 3.75 0 0 0 3.2-5.72ZM21.6 18.1a1.73 1.73 0 0 1-1.53.9H3.94a1.75 1.75 0 0 1-1.5-2.67L10.52 3.3a1.75 1.75 0 0 1 2.98 0l8.06 13.03a1.73 1.73 0 0 1 .04 1.77Z"
        fill={color}
      />
      <path
        d="M14 11h-2.23l2.09-3.49-1.72-1.02-3 5A1 1 0 0 0 10 13h2.23l-2.09 3.49 1.72 1.02 3-5A1 1 0 0 0 14 11Z"
        fill={color}
      />
    </svg>
  );
};
